// redux/authSlice.js
import { createSlice } from "@reduxjs/toolkit";

// ✅ Initial state with localStorage support
const initialState = {
  token: localStorage.getItem("token") || null,
  role: localStorage.getItem("role") || null,
  userId: localStorage.getItem("userId") || null,
  isAuthenticated: !!localStorage.getItem("token"),
}; 

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action) => {
      const { token, role, userId } = action.payload;
      state.token = token;
      state.role = role;
      state.userId = userId;
      state.isAuthenticated = true;

      // Store values in localStorage
      localStorage.setItem("token", token);
      localStorage.setItem("role", role);
      localStorage.setItem("userId", userId);
    },
    logout: (state) => {
      state.token = null;
      state.role = null;
      state.userId = null;
      state.isAuthenticated = false;

      // ✅ Only remove auth keys (avoid clearing entire localStorage)
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      localStorage.removeItem("userId");
      localStorage.removeItem("authData");
    },
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
